export class RenderTextOptions {
    public readonly fontSize?: number = 6;
    public readonly fontColor?: string = '#ffffff';
    public readonly fontWeight?: number = 400;
    public readonly maxWidth?: number = undefined;
    public readonly width?: number = undefined;
    public readonly textAlign?: 'left' | 'center' | 'right' = 'left';
}